/**
 * shopId / productId (URL パラメータ由来の文字列) が RPC に渡せる正の整数かどうかを判定する。
 * useGetShopDetail / useGetProductDetail (クエリの有効化判定) と
 * ShopDetailView / CourseDetailView (表示状態の判定) の双方で同じ基準を使うため共通化する。
 */
export function isValidId(id: string): boolean {
  return /^[1-9]\d*$/.test(id);
}
